import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Stack } from "react-bootstrap";
import * as AiIcons from "react-icons/ai";
import TableListPricesRCS from "./TableListPricesRCS";
import _ModalAddPricesRCS from "../../../modal/administration/customer/_ModalAddPricesRCS";
import { useQuery } from "@tanstack/react-query";
import { ApiEndpoint } from "../../../../utils/ApiEndpoint";
import { useAuth } from "../../../../Context/AuthContext";
import { httpClient } from "../../../../utils/HttpClient";
const ListPricesRCS = (props) => {
  const { idCustomer, uidCustomer } = props;
  const auth = useAuth();
  const { token } = auth.getSessionData();
  const [visible, setVisible] = useState({
    data: null,
    visible: false,
  });

  const {
    data: RCSPrices,
    refetch: refetchRCSPrices,
    isPending,
  } = useQuery({
    queryKey: ["RCSPrices", idCustomer],
    queryFn: async () => {
      const response = await httpClient(
        "get",
        `${ApiEndpoint}configuration/pricesrcsbycustomer/${idCustomer}`,
        {},
        token,
      );
      return response.data;
    },
    initialData: [],
    enabled: idCustomer !== null,
    refetchOnWindowFocus: false,
  });

  const { data: rcsTypes } = useQuery({
    queryKey: ["rcsTypes"],
    queryFn: async () => {
      const response = await httpClient(
        "get",
        `${ApiEndpoint}configuration/rcstypes`,
        {},
        token,
      );

      const data = Object.fromEntries(
        response.data.map((item) => [item.idrcstype, item.type]),
      ); //response.data;

      return data;
    },
    initialData: {},
    refetchOnWindowFocus: false,
  });

  return (
    <div>
      <Stack direction="horizontal" gap={2} className="wrappTitle">
        <h4> Lista de Precios RCS </h4>
        <div className="ms-auto">
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={() => setVisible({ visible: true, data: null })}
          >
            <AiIcons.AiOutlinePlus /> Agregar
          </Button>
        </div>
      </Stack>
      <TableListPricesRCS
        data={RCSPrices}
        idCustomer={props.idCustomer}
        uidCustomer={uidCustomer}
        refetchTable={refetchRCSPrices}
        isLoading={isPending}
        arrayRCSTypes={rcsTypes}
      />
      <_ModalAddPricesRCS
        title={"Precios RCS"}
        visible={visible.visible}
        onClose={() => {
          setVisible({ visible: false, data: null });
        }}
        data={{
          ...visible.data,
          idCustomer: props.idCustomer,
          uidCustomer: props.uidCustomer,
          arrayRCSTypes: rcsTypes,
        }}
        refetchRCSPrices={refetchRCSPrices}
      />
    </div>
  );
};

ListPricesRCS.propTypes = {
  idCustomer: PropTypes.number,
  partnersData: PropTypes.array,
  uidCustomer: PropTypes.string,
};

export default ListPricesRCS;
